// @flow

import { observable } from 'mobx';

export default class Bildhinweis {
  @observable id: string;
  @observable name: string;
  @observable url: string;
  
  constructor(json?: any) {
    if(json) {
      Object.assign(this, json);
    }
  }
}


// WEBPACK FOOTER //
// ./src/App/Model/Bildhinweis.js